import { FC, FunctionComponent, SVGProps } from 'react';
import cx from 'classnames';

import { ReactComponent as ParentChildIcon } from 'assets/icons/parent-child.svg';
import { ReactComponent as ChildrenIcon } from 'assets/icons/children.svg';

import { ModeOption, MYSELF_OPTION, OTHERS_OPTION } from '../utils/constants';
import styles from './BookingModeSelector.module.scss';

interface BookingModeChoice {
  option: ModeOption;
  Icon: FunctionComponent<SVGProps<SVGSVGElement>>;
}

const BOOKING_MODE_CHOICES: BookingModeChoice[] = [
  { option: MYSELF_OPTION, Icon: ParentChildIcon },
  { option: OTHERS_OPTION, Icon: ChildrenIcon },
];

export const BOOKING_MODE_SELECTOR_TITLE = 'Who are you booking for?';

interface IBookingModeSelector {
  value: ModeOption;
  onChange: (modeOption: ModeOption) => void;
}

const BookingModeSelector: FC<IBookingModeSelector> = ({ value, onChange }) => {
  return (
    <div className={styles['root']}>
      <h4 className={styles['title']} id="booking-mode-selector-title">
        {BOOKING_MODE_SELECTOR_TITLE}
      </h4>

      <div
        className={styles['options']}
        role="radiogroup"
        aria-labelledby="booking-mode-selector-title"
      >
        {BOOKING_MODE_CHOICES.map(({ option, Icon }) => {
          const isSelected = option.id === value.id;

          return (
            <button
              key={option.id}
              type="button"
              role="radio"
              aria-checked={isSelected}
              className={cx(styles['option'], {
                [styles['option-selected']]: isSelected,
              })}
              onClick={() => onChange(option)}
            >
              <Icon className={styles['option-icon']} aria-hidden="true" />

              <span className={styles['option-label']}>{option.label}</span>
            </button>
          );
        })}
      </div>
    </div>
  );
};

export default BookingModeSelector;
